import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, ImageEntity as ImageEntityType, Shapeable } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ImageAsset } from '@shapeable/ui';
import { BENTLEY_TOGETHER_LOGOS } from '../../data';

const cls = classNames('banner-outro-logos-image');

// -------- Types -------->

// -------- Props -------->

export type BannerOutroLogosImageProps = Classable & HasChildren & {
}

export const BannerOutroLogosImageDefaultProps: BannerOutroLogosImageProps = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    width: 100%;
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
};

export const BannerOutroLogosImage: Shapeable.FC<BannerOutroLogosImageProps> = (props) => {
  const { className, children } = props;

  return (
    <My.Container className={cls.name(className)}>
      <ImageAsset entity={BENTLEY_TOGETHER_LOGOS} />
    </My.Container>
  )
};

BannerOutroLogosImage.cls = cls;